/* FizzyIQ — sample kit splash: shared reveal (fizzy-skp).
   Adds .is-in to any [data-skp-reveal] section when it enters the viewport;
   IO-gated with the unconditional fallback (project gotcha: stuck-IO
   environments never fire callbacks). */
(function () {
  'use strict';

  function init() {
    var sections = document.querySelectorAll('[data-skp-reveal]');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });

    sections.forEach(function (s) {
      io.observe(s);
      setTimeout(function () {
        var r = s.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) s.classList.add('is-in');
      }, 900);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
